import httpClient from '../../global/httpClient';
import * as apis from '../../constants/api';

export const getMyCoupons = () => httpClient.get(apis.GET_MY_COUPONS);
